// Lucian UX/UI Prompt #098 · MIT License (c) 2026 Seokwoooo · https://lucianlabs.dev/uxui-prompt/#098
// 回る数字。値が変わると、変わった桁だけが上下に回る（桁ごとに 45ms ずつ遅らせる）。
import React from 'react';
import { digitsOf } from '../../utils/home-viz.mjs';
import './lucian.css';

const COL = ['0', '1', '2', '3', '4', '5', '6', '7', '8', '9'];

export default function RollingNumber({ value, suffix = '', ariaLabel }) {
  const chars = digitsOf(value);
  const digitCount = chars.filter(c => c !== ',').length;
  let di = 0;
  return (
    <div className="lx-roll" role="img" aria-label={ariaLabel || `${Math.round(Number(value) || 0)}${suffix}`}>
      {chars.map((c, i) => {
        if (c === ',') return <span key={`s${i}`} className="lx-roll__sep" aria-hidden="true">,</span>;
        // 右から数えた桁の位置で key を固定する。桁が増えても下の桁の回り方が崩れない。
        const place = digitCount - 1 - di;
        const order = di; di += 1;
        return (
          <span key={`d${place}`} className="lx-roll__col" aria-hidden="true"
            style={{ transform: `translateY(${-Number(c) * 52}px)`, transitionDelay: `${order * 45}ms` }}>
            {COL.map(d => <span key={d}>{d}</span>)}
          </span>
        );
      })}
      {suffix && <span aria-hidden="true" style={{ fontSize: 22, marginLeft: 4, alignSelf: 'flex-end', lineHeight: '40px', color: 'var(--ux-ink-3)' }}>{suffix}</span>}
    </div>
  );
}
